import { h } from "hyperapp";

export const Categories = ({
  translations,
  actions: { fetchCategories, setCategory },
  section,
  state: { categories, categoryID, clientID, disabled, loading },
}): JSX.Element => {
  return (
    <div class="col-12 col-md-4 col-lg-12 d-md-inline-block mb-3 p-0">
      <label
        style="margin-bottom:0;line-height:0;color:#666666;font-weight:bold"
        for="timespan"
      >
        {translations["fromCategory"]}
      </label>
      <select
        class="custom-select form-control"
        disabled={loading || disabled}
        id="timespan"
        onblur={event =>
          setCategory({ categoryID: event.target.value, section })
        }
        oncreate={() => fetchCategories({ clientID })}
      >
        <option selected value="">
          {translations["allCategories"]}
        </option>
        {categories.map(category => {
          return (
            <option selected={category.id === categoryID} value={category.id}>
              {category.name}
            </option>
          );
        })}
      </select>
    </div>
  );
};
